import { loadableWithFallback } from '@vision/ui/utils';
import type { HeatMapChart1Props } from './HeatMapChart1';

export const HeatMapChart1 = loadableWithFallback<HeatMapChart1Props>(() => import('./HeatMapChart1'));
